<template>
  <div class="inner-tab-wrapper mb-4">
    <b-overlay center :show="isLoading" rounded="sm">
      <div style="display: flex; flex-direction: column; gap: 1.25rem" v-if="!isLoading">
        <div class="form-card-wrapper">
          <b-card header-tag="header">
            <div
              slot="header"
              class="d-flex justify-content-between align-items-center"
            >
              <p class="mb-0 d-inline-block align-middle">
                <b>Dati Principali</b>
              </p>
            </div>
            <div class="details-card custom-grid-wrapper">
              <div class="grid-item-label">
                <strong>Codice forma di pagamento di Compagnia</strong>
              </div>
              <div class="grid-item-value">{{ dbRowData.map }}</div>
              <div class="grid-item-label"><strong>Compagnia</strong></div>
              <div class="grid-item-value">
                {{
                  dbRowData["insurer"] ? dbRowData.insurer.formatted_title : ""
                }}
              </div>
            </div>
          </b-card>
        </div>

        <div v-show="!dbRowData.mappable_id || treasuryChange">
          <validation-observer
            ref="observer"
            v-slot="{ invalid, handleSubmit }"
          >
            <b-form @submit.prevent="">
              <div class="form-card-wrapper">
                <b-card
                  header-tag="header"
                  class="mt-1"
                >
                  <div
                    slot="header"
                    class="d-flex justify-content-between align-items-center"
                  >
                    <p class="mb-0 d-inline-block align-middle">
                      <b>Mappatura Forme di pagamento - associa una forma di pagamento</b>
                    </p>
                  </div>
                  <b-card-text>
                    <div class="form-group col-md-8">
                      <base-select
                        name="salesmen"
                        vid="salesmen"
                        label="Forme di pagamento"
                        v-model="form.mappable_id"
                        :options="opt_treasuries"
                      />
                    </div>
                  </b-card-text>
                </b-card>
              </div>
              <div class="py-2 mb-4">
                <b-button
                  @click="handleSubmit(onUpdate)"
                  type="button"
                  :disabled="invalid"
                  variant="lisaweb"
                  size="sm"
                >
                  Associa
                </b-button>
              </div>
            </b-form>
          </validation-observer>
        </div>
        <div v-if="dbRowData.mappable_id && !treasuryChange">
          <div class="form-card-wrapper">
            <b-card header-tag="header">
              <div
                slot="header"
                class="d-flex justify-content-between align-items-center"
              >
                <p class="mb-0 d-inline-block align-middle">
                  <b>Forma di Pagamento</b>
                </p>
              </div>
              <div class="details-card custom-grid-wrapper">
                <div class="grid-item-label">
                  <strong>Forma di pagamento Lisaweb</strong>
                </div>
                <div class="grid-item-value">
                  {{
                    dbRowData.mappable.code +
                    "-" +
                    dbRowData.mappable.formatted_title
                  }}
                </div>
              </div>
            </b-card>
          </div>
          <div class="d-flex py-2 my-3">
            <b-button
              @click="onDetach()"
              type="button"
              class="mr-2"
              variant="lisaweb"
              size="sm"
            >
              Disassocia
            </b-button>
            <b-button
              @click="onTreasuryChange()"
              type="button"
              variant="lisaweb"
              size="sm"
            >
              Cambia forma di pagamento
            </b-button>
          </div>
        </div>
      </div>

      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import ShowMixin from "@/mixins/ShowMixin";
import FormMixin from "@/mixins/FormMixin";
import {mapGetters} from "vuex";
import BaseSelect from "@/components/form/BaseSelect";
import client from "@/repositories/api";

export default {
  name: "General",
  mixins: [FormMixin, ShowMixin],
  props: {
    resourceId: Number,
    dbRowData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    BaseSelect,
  },
  data() {
    return {
      repository: "import_map",
      isLoading: false,
      treasuryChange: false,
      opt_treasuries: [],
      form: {
        mappable_id: null,
        import_map: {
          insurer_id: null,
          treasury: {},
          map: null,
        },
      },
    };
  },
  methods: {
    onUpdate() {
      this.isLoading = true;
      this.setMandatoryField();
      this.update(this.repository, this.resourceId)
        .then(() => {
          this.$emit("fetch");
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.isLoading = false;
        });
    },
    onDetach() {
      const url = `${process.env.VUE_APP_BASE_URL}/import_maps/${this.resourceId}/detach`;

      client
        .put(url)
        .then((response) => {
          console.log("response", response);
          this.$showSnackbar({
            preset: "success",
            text: `Forma di pagamento disassociata con successo`,
          });
          this.$emit("fetch");
          this.$bvModal.hide("modal");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onTreasuryChange() {
      this.treasuryChange = true;
    },
    setMandatoryField() {
      this.form[this.repository].insurer_id = this.dbRowData.insurer_id;
      this.form[this.repository].map = this.dbRowData.map;
      this.form[this.repository].treasury = {
        [this.form.mappable_id]: {},
      };
    },
    ...mapGetters("auth", {
      getAllTreasuries: "allTreasuries",
    }),
  },
  mounted() {
    this.opt_treasuries = this.getAllTreasuries();
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      console.log("closed modal", modalId);
    });
  },
};
</script>
